import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function ProtectedRoute({ children, requireAdmin }) {
  const location = useLocation();
  const { currentUser, isAdmin, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
      </div>
    );
  }

  const isLoginPage = window.location.pathname === '/login';
  
  if (!currentUser && !isLoginPage) {
    console.log('Usuario no autenticado, redirigiendo a /login');
    return <Navigate to="/login" replace state={location.pathname.startsWith('/solicitudes-a-domicilio') ? { homeServiceReturnTo: location.pathname } : undefined} />;
  }

  if (requireAdmin && !isAdmin) {
    console.log('Usuario no es admin, redirigiendo a /');
    return <Navigate to="/" />;
  }

  return children;
} 